import React from 'react';
import { AssignmentDisplayData } from 'types/assignment';
import { CondominiumInfo } from 'types/condominium';

type Props = Pick<AssignmentDisplayData, 'condominium'>;

const displayCondominiumAddress = (data: CondominiumInfo): string => {
  const { condominioVia, condominioCAP, condominioCitta, condominioProv } = data;
  const locationInfoOrder = [condominioCAP, condominioCitta, condominioProv ? `(${condominioProv})` : ''];
  return `${condominioVia ? `${condominioVia}\n` : ''}${locationInfoOrder.filter((o) => o).join(' ')}`;
};

export const CondominiumData: React.FC<Props> = ({ condominium }) => {
  const address = displayCondominiumAddress(condominium);
  return (
    <div className="row no-gutters">
      <div className="col-12 mb-3">
        <p className="caption font__grey tran-uppercase">condominio</p>
        {condominium.condominioNome && <p>{condominium.condominioNome}</p>}
        {address && <p className="white_space__prewrap">{address}</p>}
        {condominium.condominioCF && (
          <div className="d-inline-flex align-items-end">
            <p className="caption mr-2">Cod. Fisc.</p>
            <p>{condominium.condominioCF}</p>
          </div>
        )}
      </div>
    </div>
  );
};
